import { render, staticRenderFns } from "./RegistersEditor.vue?vue&type=template&id=32d07655&scoped=true"
import script from "./RegistersEditor.vue?vue&type=script&lang=js"
export * from "./RegistersEditor.vue?vue&type=script&lang=js"
import style0 from "./RegistersEditor.vue?vue&type=style&index=0&id=32d07655&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d07655",
  null
  
)

export default component.exports